export default __webpack_public_path__ + "731ee5c68122fecebc83f28ebc7f09a5.svg";